import { render, staticRenderFns } from "./MemberPointHistory.vue?vue&type=template&id=17206dbe&"
import script from "./MemberPointHistory.vue?vue&type=script&lang=js&"
export * from "./MemberPointHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17206dbe')) {
      api.createRecord('17206dbe', component.options)
    } else {
      api.reload('17206dbe', component.options)
    }
    module.hot.accept("./MemberPointHistory.vue?vue&type=template&id=17206dbe&", function () {
      api.rerender('17206dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/members/member-manage/MemberPointHistory.vue"
export default component.exports